import { useState } from 'react'
import useForm from 'tennders-common/form/hooks/useForm'
import { apiPost } from 'tennders-stracture/libs/api'

const useTransactionOnHold = ({ initialForm, id }) => {
  const { form, onChange, errors } = useForm({ initialForm })
  const [submitting, setSubmitting] = useState(false)
  const [success, setSuccess] = useState(false)
  const [fail, setFail] = useState(false)

  const onSubmit = async () => {
    setSubmitting(true)
    const data = await apiPost(`/broker/transactions/${id}/hold`, { reason: form.reason })
    if (data) {
      setSuccess(true)
    } else {
      setFail(true)
    }
    setSubmitting(false)
  }

  return {
    success,
    fail,
    onSubmit,
    submitting,
    form,
    onChange,
    errors
  }
}

export default useTransactionOnHold
